@if (shipmentLines && shipmentLines.length > 0) {
  <div class="row">
    <div class="col-12">
      <div class="product-detail_product-order-history">
        <h1
        i18n="
          product detail: order history
          header@@product.detail.product-order-history.header"
          >
        Order history
      </h1>
      </div>
      <div class="product-order-history__table-wrapper">
        <table class="product-order-history__table">
          <thead class="">
            <tr>
              <th
                class="product-order-history__deliverydate"
              i18n="
                product detail order history: Delivery Date table
                header@@product.detail.product-order-history.table.delivery-date"
                id="deliverydate"
                >
              Delivery date
            </th>
              <th
                class="product-order-history__amount"
              i18n="
                product detail order history: Amount table
                header@@product.detail.product-order-history.table.amount"
                id="amount"
                >
              Amount
            </th>
              <th
              i18n="
                product detail order history: Article table
                header@@product.detail.product-order-history.table.article"
                id="article"
                >
              Article
            </th>
              <th
                class="product-order-history__potsize"
              i18n="
                product detail order history: Pot size table
                header@@product.detail.product-order-history.table.potsize"
                id="potsize"
                >
              Pot size
            </th>
              <th
                class="product-order-history__potheight"
              i18n="
                product detail order history: Pot height table
                header@@product.detail.product-order-history.table.potheight"
                id="potheight"
                >
              Pot height
            </th>
              <th
                class="product-order-history__price"
              i18n="
                product detail order history: Price table
                header@@product.detail.product-order-history.table.price"
                id="price"
                >
              Price
            </th>
            </tr>
          </thead>
          <tbody>
            @for (shipmentLine of shipmentLines; track shipmentLine; let i = $index) {
              <tr>
                <td class="deliverydate">
                  <p
                    class="label"
                i18n="
                  product detail order history: Delivery Date table
                  header@@product.detail.product-order-history.table.delivery-date"
                    >
                Delivery date
              </p>
                  {{ shipmentLine.shipmentDate | customDate: "dd-MM-yyyy" }}
                </td>
                <td class="amount">
                  <p
                    class="label"
                i18n="
                  product detail order history: Amount table
                  header@@product.detail.product-order-history.table.amount"
                    >
                Amount
              </p>
                  {{ shipmentLine.boxQty }} x {{ shipmentLine.qtyPerBox }}
                </td>
                <td class="article">
                  <p
                    class="label"
                i18n="
                  product detail order history: Article table
                  header@@product.detail.product-order-history.table.article"
                    >
                Article
              </p>
                  {{ shipmentLine.description }}
                </td>
                <td class="potsize">
                  <svg
                    class="icon-potsize"
                    height="11"
                    viewBox="0 0 16 11"
                    width="16"
                    >
                    <use xlink:href="/images/icons/svg-sprite.svg#potsize"></use>
                  </svg>
                  {{
                  shipmentLine.gradeCodeDescription1
                  ? shipmentLine.gradeCodeDescription1
                  : 0
                  }}
                </td>
                <td class="potheight">
                  <svg
                    class="icon-potheight"
                    height="11"
                    viewBox="0 0 6 11"
                    width="6"
                    >
                    <use xlink:href="/images/icons/svg-sprite.svg#potheight"></use>
                  </svg>
                  {{
                  shipmentLine.gradeCodeDescription2
                  ? shipmentLine.gradeCodeDescription2
                  : 0
                  }}
                </td>
                <td class="price">
                  {{ applicationService.getUserCurrency() }}
                  {{ shipmentLine.previousPrice | number: "1.2-2" }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (showMoreEnabled) {
        <div class="product-order-history__show-more">
          <button
            (click)="toggleAllShipmentLines()"
            class="order-history-show-all-button"
            >
            @if (!showAllShipmentLines) {
              <span
          i18n="
            product detail order history: Show more button
            text@@product.detail.product-order-history.table.show-more"
                >Show more orders</span
                >
              }
              @if (showAllShipmentLines) {
                <span
          i18n="
            product detail order history: Show less button
            text@@product.detail.product-order-history.table.show-less"
                  >Show less orders</span
                  >
                }
              </button>
            </div>
          }
        </div>
      </div>
    }
